import React from "react";
import { Button, Grid, Typography } from "@mui/material";

const ModalError = ({
  onClose,
  confirm,
  title,
  descriptionOne,
  descriptionTwo,
  descriptionThree,
  copyButton,
  modalInfo,
}) => {
  return (
    <Grid
      container
      item
      xs={11}
      md={5}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "100%",
        width: { xs: "90%", sm: "80%" },
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
        }}
      >
        <Grid item xs={0} style={{ marginLeft: "15px" }}>
          {/* {modalInfo ? (
            <div className="icon-modal-info" />
          ) : (
            <div className="icon-error-message" />
          )} */}
        </Grid>
        <Grid item xs={10}>
          <Typography
            className="color-blue-dark"
            style={{ fontSize: "18px", marginTop: "3px", fontWeight: 600 }}
          >
            {title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={1}
          style={{
            marginRight: "15px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div onClick={onClose} className="icon-modal-close" />
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          style={{
            padding: "10px 15px 0px 15px",
            marginTop: "20px",
          }}
          className="color-blue-dark"
        >
          {descriptionOne}
        </Typography>
        <Typography
          style={{
            padding: "0px 15px",
          }}
          className="color-blue-dark"
        >
          {descriptionTwo}
        </Typography>
        {descriptionThree && (
          <Typography
            style={{
              padding: "0px 15px",
            }}
            className="color-blue-dark"
          >
            {descriptionThree}
          </Typography>
        )}
      </Grid>

      <Grid container item xs={12} style={{ marginTop: "20px" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          <Button className="button-bg-blue" onClick={confirm}>
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {" "}
              {copyButton}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalError;
